import { css } from "@emotion/react";
import Box from "@mui/material/Box";
import type { Overwrite } from "@mui/types";
import { theme } from "@polifonia/theme";
import type { FC } from "react";

import { MotifIcon } from "@/components/MotifIcon";
import type { InterludeTypes } from "@/interlude";
import { defineStyles } from "@/internal/emotion";

namespace ChannelIcon {
  export interface OwnProps {
    type: InterludeTypes["Channel"]["type"];
    /**
     * Only meaningful when `type === "wccs"` — shows the WebStream icon
     * instead of the regular WebChat one for channels flagged via
     * `channelInformation.type === "web-streams"`.
     */
    isWebStream?: boolean;
  }

  export type Props = Overwrite<React.ComponentProps<typeof Box>, OwnProps>;
}

const styles = defineStyles({
  icon: css({
    color: theme.colors.staticFgPrimary,
  }),
});

const channelIconMap: Record<ChannelIcon.Props["type"], React.ReactNode> = {
  wccs: <MotifIcon un-i-motif="earth" css={styles.icon} />,
  whatsapp: <MotifIcon un-i-motif="whatsapp_color" />,
  line: <MotifIcon un-i-motif="line_color" />,
  fb: <MotifIcon un-i-motif="facebook_color" />,
  ig: <MotifIcon un-i-motif="instagram_color" />,
  email: <MotifIcon un-i-motif="email" css={styles.icon} />,
};

export const ChannelIcon: FC<ChannelIcon.Props> = ({
  type,
  isWebStream = false,
  ...props
}) => {
  return (
    <Box
      sx={{
        fontSize: 24,
      }}
      {...props}
    >
      {type === "wccs" && isWebStream ? (
        <MotifIcon un-i-motif="window_bubble_chat" css={styles.icon} />
      ) : (
        channelIconMap[type]
      )}
    </Box>
  );
};
